import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import { ResourceLinks } from "../../../../constants";
import { useSelector } from "../../../../store";

export default function WebNumeracySelectText({ question, onAnswer = () => {} }) {
    const questionData = question;
    const learnerState = useSelector((state) => state.learner || {});
    const data = learnerState?.details?.testLevel === "vfh" ? questionData?.vfh : questionData?.acsf4;
    const imagesResources = ResourceLinks.llnQuizImage;

    const [availableChoices, setAvailableChoices] = useState(data.choices);
    const [answer, setAnswer] = useState([]);

    // every time question change we will set to reset needed to reset
    useEffect(() => {
        setAvailableChoices(data.choices);
        setAnswer([]);
    }, [question,
        data.choices,
    ]);

    const handleClickChoice = (choice) => {
        let ans = [...answer];
        if (!data.multiple) {
            ans = []; // reset for string
        }

        ans = [
            ...ans,
            choice.value
        ];
        
        setAnswer(ans);
        checkCanProceed(ans);
    }

    const checkCanProceed = (ans) => {
        const canProceed = ans.length > 0;

        const finalAnswer = data.multiple ? ans : (ans[0] ?? "");

        onAnswer({
            canProceed,
            answer: finalAnswer,
        });
    }

    return (
        <Box
            sx={{
                // width: "1000px",
            }}
        >
            {/* For Choices */}
            <Box sx={{
                padding: "30px",
                display: "grid",
                gridTemplateColumns: "repeat(2, 1fr)",
                textAlign: "center",
            }}>
                {availableChoices.map((choice, index) => (
                    <Box key={index} 
                        component="span"
                        sx={{
                            margin: "0px 10px 20px",
                            width: "235px",
                            height: "50px",
                            justifySelf: "center",
                            display: "inline-table",
                            cursor: "pointer",
                            userSelect: "none",
                            backgroundColor: answer.includes(choice.value) ? "#afe23e" : "#dadada",
                            borderBottom: answer.includes(choice.value) ? "10px solid #639729" : "10px solid #808080",
                            fontWeight: "bold",
                            textAlign: "center",
                            fontSize: "18px",
                        }}
                        onClick={() => {handleClickChoice(choice)}}
                    >
                        <Box component="span"
                            sx={{
                                display: "table-cell",
                                verticalAlign: "middle",
                                cursor: "pointer",
                                fontWeight: "bold",
                                textAlign: "center",
                            }}
                        >
                            <Box component="span">{choice.value}</Box>
                        </Box>
                    </Box>
                ))}
            </Box>

            <Box component="img"
                src={`${imagesResources}${data.image}`}
                alt="Img"  
            />
        </Box>
    );
};